import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createElementBlock as _createElementBlock, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b42d358e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "notify",
  style: {"text-align":"left"}
}, [
  /*#__PURE__*/_createElementVNode("h3", {
    style: {"text-align":"center"},
    class: "vo-ft-dag"
  }, "请仔细阅读上传内容须知"),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("1、上传的文件必须为双方或多方均"),
    /*#__PURE__*/_createElementVNode("span", null, "已确认并有效盖章"),
    /*#__PURE__*/_createTextVNode("。且"),
    /*#__PURE__*/_createElementVNode("span", null, "认同"),
    /*#__PURE__*/_createTextVNode("文件的法律有效性！")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("2、上传的文件必须为依照PDF文档,按照原文件的顺序形成一个"),
    /*#__PURE__*/_createElementVNode("span", null, "独立、整体的文档"),
    /*#__PURE__*/_createTextVNode("！")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode("3、上传的文件必须为彩色扫描件，可"),
    /*#__PURE__*/_createElementVNode("span", null, "清楚的识别"),
    /*#__PURE__*/_createTextVNode("文件的内容及相关的图表、签章等！")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, "4、上传的文件必须为相关类型的合同、协议等名字命名，避免以数字、系列号命名！"),
  /*#__PURE__*/_createElementVNode("p", null, "5、上传的文件仅在该节点可以进行上传、修正等操作，其他节点不能上传及修改！"),
  /*#__PURE__*/_createElementVNode("p", null, "6、上传的文件在其他环节只能作为查看、浏览、下载等操作。")
], -1))
const _hoisted_2 = { style: {"text-align":"center"} }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 取 消 ")
const _hoisted_4 = { "element-loading-text": "正在提交数据，请稍后" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-upload__text" }, [
  /*#__PURE__*/_createTextVNode("拖动文件到此处"),
  /*#__PURE__*/_createElementVNode("em", null, "上传")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "el-upload__tip" }, "允许上传文件类型：pdf文档,office文档,图像(jpg,jpeg,bmp)", -1))
const _hoisted_7 = { style: {"text-align":"center"} }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 提 交 ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 取 消 ")

import { reactive, ref, unref } from 'vue';
import { FormRules, ElForm, ElMessage } from 'element-plus';
import { CtAgreeApi } from '@/apis/contract/contract.api';
import { config } from '@/config/config';
import { Session } from '@/utils/storage';


export default /*#__PURE__*/_defineComponent({
  emits: ['refresh'],
  setup(__props, { expose, emit: $emits }) {


const elFormRef = ref<ComponentRef<typeof ElForm>>();

const { base_url } = config;

const uploadSchema = ref<any>({
	categroy_id: '0afff935-9ffa-4907-8ce8-a8bf3463b41e',
	ct_num: '',
	material_type: '6c395bee-3033-4b14-b7a0-595d5f1a1556',
	material_type_desc: '签章文件',
});

const state = reactive({
	showDialog: false,
	showUpDialog: false,
	countdown: 0,
	buttonText: '确认',
	loading: false,
	upload: {
		url: `${base_url}/api/sysmaterial/uploadfile`,
		headers: { Authorization: '' },
	},
	detail: {} as any,
	rules: {
		remark: [{ required: true, message: '审核批示不能为空', trigger: 'blur' }],
	} as FormRules,
});

const schema = ref<any>({
	id: '',
	revision: '',
	remark: '',
	file_total: 0,
	material_list: [],
});

let timer: any = null;

/* 确认按钮倒计时 */
const startCountdown = () => {
	state.countdown = 10;
	state.buttonText = `${state.countdown}秒后确认`;
	timer = setInterval(() => {
		state.countdown--;
		if (state.countdown <= 0) {
			clearInterval(timer);
			state.buttonText = '确认';
		} else {
			state.buttonText = `${state.countdown}秒后确认`;
		}
	}, 1000);
};

const actions = {
	/* 操作警告 */
	notify: (contract: any) => {
		const { contract_id, revision } = contract;

		unref(schema).id = contract_id;
		unref(schema).revision = revision;
		unref(uploadSchema).ct_id = contract_id;

		if (timer) {
			clearInterval(timer);
			timer = null;
		}

		startCountdown();

		const tokenStr = Session.get('token') as string;
		const token = (str: any) => {
			try {
				return JSON.parse(str);
			} catch (e) {
				return str;
			}
		};

		state.upload.headers.Authorization = `Bearer ${token(tokenStr)}`;
		state.showDialog = true;
	},

	/* 用户操作 */
	sure: () => {
		state.showDialog = false;
		state.showUpDialog = true;
	},

	/* 提交操作 */
	submit: async () => {
		const subData = unref(schema);

		if ((subData.material_list || []).length <= 0) {
			ElMessage.warning('未上传附件');
			return;
		}

		state.loading = true;
		const { succeeded, errors } = await CtAgreeApi(subData);
		state.loading = false;
		if (!succeeded) {
			ElMessage.error(errors);
		} else {
			ElMessage.success('操作成功');
			$emits('refresh', succeeded);
			state.showDialog = false;
			state.showUpDialog = false;
		}
	},
};

/* 上传成功 */
const onUploadSuccess = (res: IResponse, file: any) => {
	const { succeeded, data } = res;
	if (!succeeded) {
		ElMessage.error('文件上传失败');
	} else {
		ElMessage.success('上传成功');
		unref(schema).material_list!.push(data.id);
	}
};

expose({ showNotify: actions.notify });

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_upload_filled = _resolveComponent("upload-filled")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_dialog, {
      title: "操作警告！",
      modelValue: _unref(state).showDialog,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).showDialog) = $event)),
      width: "600"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_el_button, {
            size: "small",
            type: "primary",
            disabled: _unref(state).countdown > 0,
            onClick: actions.sure
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(state).buttonText), 1)
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]),
          _createVNode(_component_el_button, {
            size: "small",
            type: "info",
            disabled: _unref(state).loading,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(state).showDialog = false))
          }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "上传盖章文件",
      modelValue: _unref(state).showUpDialog,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(state).showUpDialog) = $event)),
      width: "520"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_el_button, {
            size: "small",
            type: "primary",
            disabled: _unref(state).loading,
            onClick: actions.submit
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]),
          _createVNode(_component_el_button, {
            size: "small",
            type: "info",
            disabled: _unref(state).loading,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(state).showUpDialog = false))
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ]),
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_unref(state).showUpDialog)
            ? (_openBlock(), _createBlock(_unref(ElForm), {
                key: 0,
                ref_key: "elFormRef",
                ref: elFormRef,
                model: schema.value,
                "label-position": "top",
                size: "small"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "合同盖章文件" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_upload, {
                        drag: "",
                        multiple: "",
                        style: {"width":"100%"},
                        data: uploadSchema.value,
                        action: _unref(state).upload.url,
                        headers: _unref(state).upload.headers,
                        "on-success": onUploadSuccess
                      }, {
                        tip: _withCtx(() => [
                          _hoisted_6
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_el_icon, { class: "el-icon--upload" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_upload_filled)
                            ]),
                            _: 1
                          }),
                          _hoisted_5
                        ]),
                        _: 1
                      }, 8, ["data", "action", "headers"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"]))
            : _createCommentVNode("", true)
        ])), [
          [_directive_loading, _unref(state).loading]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})